"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)(() => ({
    container: {
        flex: 1,
        position: 'fixed',
        textAlign: 'center',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgb(0,0,0,0.2)',
        zIndex: 2000,
    },
    spinner: {
        position: 'fixed',
        top: '50vh',
    },
}));
const Overlay = (props) => {
    const classes = useStyles();
    const { children, loading } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children && children,
        loading && (react_1.default.createElement(Box_1.default, { className: classes.container },
            react_1.default.createElement(CircularProgress_1.default, { className: classes.spinner })))));
};
Overlay.defaultProps = {
    loading: false,
};
Overlay.propTypes = {
    loading: prop_types_1.default.bool,
    children: prop_types_1.default.any,
};
exports.default = Overlay;
